import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';
import type { Section } from '../../../menu/dto/section';

export class WebSocketReceiveReloadSection extends WebSocketReceiveWithSigningUserId {
  override payload: {
    SigningUserId: string;
    SectionId: string;
    TemplateSectionId: string;
  };

  isAboutThis(section: Section): boolean {
    if (!section) return false;
    const theSectionChanged = section?.id === this.payload?.SectionId;
    const theTemplateIAmCreatedFromChanged = section?.templateSectionId === this.payload?.TemplateSectionId;
    return theSectionChanged || theTemplateIAmCreatedFromChanged;
  }
}
